module.exports = __webpack_public_path__ + "fonts/4aa0d2a387168f2a1c612c7b8ea2ceee.svg";